// NOTE. Remove React import. if you want to keep React import, you do not filter anything
import React from 'react';
import type { SVGProps } from 'react';
export const SvgArrowDown = (props: SVGProps<SVGSVGElement>) => (
    <svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 25" {...props}>
        <path
            d="M20 12.5L18.59 11.09L13 16.67V4.5H11V16.67L5.42 11.08L4 12.5L12 20.5L20 12.5Z"
            fill="currentColor"
        />
    </svg>
);
